import * as React from 'react';
import { APIFieldErrors } from '../../api/api';
import { inject } from 'mobx-react';
import { InjectTranslate } from '../app/app';

interface InputErrorProps {
  readonly errors: APIFieldErrors | undefined;
}

export class InputErrorC extends React.Component<InputErrorProps & InjectTranslate> {

  public render() {
    const { errors, t } = this.props;
    if (!errors || !errors.length) {
      return null;
    }
    return (
      <div className="input-error">{t(errors[0], undefined, true)}</div>
    );
  }
}

export const InputError = inject('t')(InputErrorC) as React.ComponentClass<InputErrorProps>;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/input-error.tsx